module.exports = __webpack_public_path__ + "img/nauru.3148eeca.png";